export default "__VITE_ASSET__DV98MuyH__"